<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    class="z-max"
    :title="title"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ subtitle }}
      </p>
      <div class="col-12">
        <copy-link
          data-e2e="dialog-link"
          :link="link"
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonClose')"
        data-e2e="button-continue"
        @click="hide"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import CopyLink from 'components/Modals/CopyLink';
import {
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';

export default {
  name: 'CopyLinkDialog',

  components: {
    CopyLink,
    HrDismissBtn,
    HrFormDialog,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      required: true,
    },

    link: {
      type: String,
      required: true,
    },
  },

  emits: ['hide'],

  methods: {

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()
  },
};
</script>
